import PrescriptionCreate from '@screens/vision/prescription/create'

export default function PrescriptionCreatePage() {
  return <PrescriptionCreate />
}
